import React, { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { resolveDashboardPath } from "../../../config/routes";
import { useTwgoldAuth } from '../contexts/useTwgoldAuth';
import '../../../styles/TwgoldLogin.css';

const TwgoldLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const { twgold_login } = useTwgoldAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setBtnLoading(true);
  
    if (!email || !password) {
      setError('Please enter both email and password');
      setBtnLoading(false);
      return;
    }
  
    try {
      const result = await twgold_login(email, password);

      if (!result.success) {
        setError(result.message || 'Login failed');
        return;
      }
      
      const role = result.user?.role;
      const redirectPath =
        location.state?.from?.pathname || resolveDashboardPath(role);
      
      navigate(redirectPath, { replace: true });
  
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setBtnLoading(false);
    }
  };
  return (
    <div className="twgold_login_container">
      <div className="twgold_login_card">
        
        <div className="twgold_login_header">
          <h1 className="twgold_login_title">TW Gold Login</h1>
        </div>

        <form onSubmit={handleSubmit} className="twgold_login_form">
          
          {error && (
            <div className="twgold_error_message">
              {error}
            </div>
          )}

          {/* EMAIL */}
          <div className="twgold_input_group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="twgold_input_field"
              placeholder=" "
              required
              disabled={btnLoading}
            />
            <label className="twgold_input_label">
              Email Address
            </label>
          </div>

          {/* PASSWORD */}
          <div className="twgold_input_group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="twgold_input_field"
              placeholder=" "
              required
              disabled={btnLoading}
            />
            <label className="twgold_input_label">
              Password
            </label>
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            className="twgold_login_button"
            disabled={btnLoading}
          >
            {btnLoading ? (
              <>
                <span className="twgold_loading_spinner_small"></span>
                Authenticating...
              </>
            ) : (
              'Sign In'
            )}
          </button>

        </form>
      </div>
    </div>
  );
};

export default TwgoldLogin;